//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    mapActions,
    mapState
} from "vuex";
import logger from "@/utils/logger";

export default {
    components: {},
    data() {
        return {
            pagination: {
                rowsPerPage: 30, // current rows per page being displayed
                sortBy: "id",
                descending: false,
            },
            tabsettings: "location",
            warehouseColumn: [{
                    name: "id",
                    align: "left",
                    label: "id",
                    field: "id",
                    style: "width: 20px",
                    sortable: true,
                },

                {
                    name: "warehouseName",
                    align: "left",
                    label: this.$t("stock.warehouse"),
                    field: "warehouseName",
                    sortable: true,
                },
                {
                    name: "streetName",
                    align: "left",
                    label: this.$t("stock.streetName"),
                    field: "streetName",
                    sortable: true,
                },

                {
                    name: "postCode",
                    align: "left",
                    label: this.$t("stock.postCode"),
                    field: "postCode",
                    sortable: true,
                },
                {
                    name: "city",
                    align: "left",
                    label: this.$t("stock.city"),
                    field: "city",
                    sortable: true,
                },
                {
                    name: "gln",
                    align: "left",
                    label: "Gln",
                    field: "gln",
                    sortable: true,
                },
                {
                    name: "isRemoteWarehouse",
                    align: "left",
                    label: "Eksternt lager",
                    field: (row) => {
                        if (row.isRemoteWarehouse) {
                            return "Ja"
                        } else {
                            return "Nei"
                        }
                    },
                    sortable: true,
                },
                {
                    name: "includeInStockBalance",
                    align: "left",
                    label: "Inkluder i kalkulering",
                    field: (row) => {
                        if (row.includeInStockBalance) {
                            return "Ja"
                        } else {
                            return "Nei"
                        }
                    },
                    sortable: true,
                }

            ],
            locationColumn: [{
                    name: "id",
                    align: "left",
                    label: "id",
                    field: "id",

                    sortable: true,
                },
                {
                    name: "warehouseName",
                    align: "left",
                    label: this.$t("stock.warehouse"),
                    field: "warehouseName",
                    sortable: true,
                },
                {
                    name: "locationGroupName",
                    align: "left",
                    label: this.$t("order.locationGroupName"),
                    field: "locationGroupName",
                    sortable: true,
                },
                {
                    name: "quantity",
                    align: "left",
                    label: "Antall",
                    field: "quantity",
                    sortable: true,
                },
                {
                    name: "locationName",
                    align: "left",
                    label: this.$t("order.locationName"),
                    field: "locationName",
                    sortable: true,
                },
                {
                    name: 'actions',
                    align: "right",
                    label: 'Lås Lokasjon'
                }
            ],
            warehouse: {},
            location: {},
            LocationsWithQuantity: [],
            promptLocation: false,
            promptWarehouse: false,
        };
    },

    mounted: function () {},

    async created() {
        this.LocationsWithQuantity = await this.getLocationsWithQuantity();
    },

    computed: {
        ...mapState("main", [
            "warehouses",
            "locations",
            "suppliers"
        ]),
    },

    methods: {

        async lockLocation(row) {
            var putObject = {}
            putObject["id"] = row.id;
            putObject["isDeleted"] = !row.isDeleted;
            putObject["locationGroupName"] = row.locationGroupName;
            putObject["locationName"] = row.locationName;
            putObject["quantity"] = row.quantity;
            putObject["warehouseId"] = row.warehouseId;
            putObject["warehouseName"] = row.warehouseId;

            await this.putLocation(putObject);
            this.LocationsWithQuantity = await this.getLocationsWithQuantity();
        },

        onCreateClickWarehouse() {
            this.warehouse = {
                warehouseName: "",
                streetName: "",
                postCode: "",
                city: "",
                gln: "",
                isRemoteWarehouse: false,
                includeInStockBalance: true,
                priority: null,
                supplierId: null,

            }
            this.promptWarehouse = true;
        },

        onCreateClickLocation() {
            this.location = {
                locationName: "",
                locationGroupName: "",
                warehouseName: "",
            };

            this.promptLocation = true;
        },

        onRowClickWareHouse(evt, row) {
            this.warehouse = row;
            this.promptWarehouse = true;
        },
        onRowClickLocation(evt, row) {
            if(!row.isDeleted) {
                this.location = row;           
                this.promptLocation = true;
            }
        },

        async createOrUpdateWarehouse() {
            try {
                if (this.warehouse.id) {
                    await this.putWarehouse(this.warehouse);
                } else {
                    await this.postWarehouse(this.warehouse);
                }
                this.$q.notify({
                    type: "positive",
                    message: this.$t("common.saveOk"),
                });
            } catch (error) {
                logger.log("error", error);

                this.$q.notify({
                    type: "negative",
                    message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(error)}`,
                });
            }
            this.getWarehouse();
        },
        async createOrUpdateLocation() {

            try {
                if (this.location.id) {
                    await this.putLocation(this.location);
                } else {
                    await this.postLocation(this.location);
                }
                this.$q.notify({
                    type: "positive",
                    message: this.$t("common.saveOk"),
                });
            } catch (error) {
                logger.log("error", error);
                this.$q.notify({
                    type: "negative",
                    message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(error)}`,
                });
            }
            await this.getLocation();
            this.LocationsWithQuantity = await this.getLocationsWithQuantity();
        },

        ...mapActions("main", [
            "putWarehouse",
            "postWarehouse",
            "putLocation",
            "postLocation",
            "getLocation",
            "getLocationsWithQuantity",
            "getWarehouse",
        ]),
    },

};
